// Configuración de Auth0
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "dev-xf0215785e11ch3h.us.auth0.com",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "AcKC263ToVp3yfi8BdLmfxaCGVrnSh3B",
  redirectUri: window.location.origin,
  audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN || "dev-xf0215785e11ch3h.us.auth0.com"}/api/v2/`,
  scope: "openid profile email"
};